var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.color)?_c('Picker',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.onAway),expression:"onAway"}],class:_vm.$css(_vm.styles.picker),attrs:{"value":_vm.color},on:{"input":_vm.onChange}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }